import { Box } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import EyeCloseIcon from '~/components/SVG/SvgEyes/EyeClose.svg?react';

const styles: { icon: SxProps<Theme> } = {
  icon: (theme: Theme) => ({
    width: '25px',
    height: '25px',
    color: theme.palette.text.primary,
    [theme.breakpoints.down('sm')]: {
      width: '15px',
      height: '15px',
    },
  }),
};

const SvgEyeClose = () => {
  return <Box component={EyeCloseIcon} sx={styles.icon} />;
};

export default SvgEyeClose;
